import React from "react";
import styled from "styled-components";
import Category from "../components/Home/Category";
import Header from "../components/Navbar";
import MainSlider from "../components/Home/MainSlider";
import Container from "../UI/Container";
import CategoryColumn from "../components/Home/CategoryColumn";
import Subscribe from "../components/Subscribe";
import Footer from "../components/Footer";
import { UsePostsContext } from "../store/contexts/posts.context";
import { useEffect } from "react";

function HomePage() {
  const {
    recents,
    liked,
    viewed,
    rated,
    getLiked,
    getRated,
    getRecents,
    getViewed,
  } = UsePostsContext();
  useEffect(() => {
    getRecents(0, 10);
    getViewed(0, 10);
    getRated(0, 10);
    getLiked(0, 10);
  }, []);
  return (
    <>
      <Wrapper>
        <Header />
        <div className="devider"></div>
        <Category />
        <div className="devider"></div>
        <MainSlider data={recents.slice(0, 6)} />
      </Wrapper>
      <Container>
        <div className="devider"></div>
        <CategoryColumn
          title={"Most Viewed"}
          path="viewed"
          data={viewed.slice(0, 6)}
        />
        <div className="devider"></div>
        <CategoryColumn
          title={"Most Rated"}
          path="rated"
          row
          data={rated.slice(0, 6)}
        />
        <div className="devider"></div>
        <CategoryColumn
          title={"Most Liked"}
          path="liked"
          data={liked.slice(0, 6)}
        />
        <div className="devider"></div>
        <div className="devider"></div>
        <Subscribe />
        <div className="devider"></div>
        <div className="devider"></div>
      </Container>
      <Footer />
    </>
  );
}

export default HomePage;

const Wrapper = styled.div`
  background: linear-gradient(180deg, #f7f7f7, #edf2f7);
`;
